module.exports = __webpack_public_path__ + "img/arrow__select.69b416ae.svg";